import toPropertyKey from './toPropertyKey.js';

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

export { _defineProperty as default };
//# sourceMappingURL=defineProperty.js.map
